import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

import PropTypes from 'prop-types';

const EmailManualSyncConfirmationModal = ({
	open,
	onClose,
	onConfirm
}) => {

	return (
		<Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
			<DialogTitle>Sync to CRM</DialogTitle>
			<DialogContent dividers sx={{ pt: 3, paddingBottom: '24px' }}>
				<Box sx={{ mt: 2, height: '20px', width: '100%', marginBottom: '16px' }}>
					<Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>
						Pressing Confirm will start the process of syncing ingested emails to the CRM.
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions sx={{ p: 2 }}>
				<Button
					onClick={onClose}
					variant='outlined'
					size='medium'
					sx={{ mr: 1 }}
				>
					Cancel
				</Button>

				<LoadingButton
					variant='outlined'
					onClick={onConfirm}
					size='medium'
				>
					Confirm
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

EmailManualSyncConfirmationModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default EmailManualSyncConfirmationModal;
